// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1o5WC","modalForm":"UpgradeEpcsModal_modalForm__1swHP","modalFooter":"UpgradeEpcsModal_modalFooter__3g6X_"};